/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';
import type { ListOrganizationsResponseMeta } from './ListOrganizationsResponseMeta';
import {
    ListOrganizationsResponseMetaFromJSON,
    ListOrganizationsResponseMetaFromJSONTyped,
    ListOrganizationsResponseMetaToJSON,
    ListOrganizationsResponseMetaToJSONTyped,
} from './ListOrganizationsResponseMeta';

/**
 * 
 * @export
 * @interface ListOrganizationsResponse
 */
export interface ListOrganizationsResponse {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof ListOrganizationsResponse
     */
    organizations: Array<Organization>;
    /**
     * 
     * @type {ListOrganizationsResponseMeta}
     * @memberof ListOrganizationsResponse
     */
    meta: ListOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ListOrganizationsResponse interface.
 */
export function instanceOfListOrganizationsResponse(value: object): value is ListOrganizationsResponse {
    if (!('organizations' in value) || value['organizations'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListOrganizationsResponseFromJSON(json: any): ListOrganizationsResponse {
    return ListOrganizationsResponseFromJSONTyped(json, false);
}

export function ListOrganizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOrganizationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'organizations': ((json['organizations'] as Array<any>).map(OrganizationFromJSON)),
        'meta': ListOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ListOrganizationsResponseToJSON(json: any): ListOrganizationsResponse {
    return ListOrganizationsResponseToJSONTyped(json, false);
}

export function ListOrganizationsResponseToJSONTyped(value?: ListOrganizationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizations': ((value['organizations'] as Array<any>).map(OrganizationToJSON)),
        'meta': ListOrganizationsResponseMetaToJSON(value['meta']),
    };
}

